import { ContainerModule } from "inversify";
import {
  CadastroDeIntegracaoDi,
  CadastroDeIntegracaoGateway
} from "../services/CadastroDeIntegracaoGateway";
import CadastroDeIntegracaoGatewayAdapter from "../services/CadastroDeIntegracaoGatewayAdapter";

const cadastroDeIntegracaoContainer = new ContainerModule((bind) => {
  bind<CadastroDeIntegracaoGateway>(CadastroDeIntegracaoDi).to(
    CadastroDeIntegracaoGatewayAdapter
  );
});

export { cadastroDeIntegracaoContainer };
